import Logo from "../../components/Logo/Logo";
import { Home } from "lucide-react";

import "./Unauthorized.css";
import NavItem from "../../components/NavItem/NavItem";

function Unauthorized() {
  return (
    <>
      <title>Projektkontrolle - Zugriff verweigert</title>
      <div className="unauthorized-container">
        <Logo />

        <div className="unauthorized-top-section">
          <h1 className="unauthorized-page-title">Zugriff verweigert</h1>
          <h2 className="unauthorized-page-subtitle">
            Leider haben Sie keine Berechtigung für diese Seite
          </h2>
        </div>

        <div className="unauthorized-bottom-section">
          <div className="unauthorized-navigation-icons">
            <NavItem destination="/" icon={Home} label="Zur Startseite" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Unauthorized;
